const normalizeText = (value) => String(value ?? "").trim();

const isGloballyUniqueDraftLineId = (value) =>
  /^draft-[a-z0-9-]{12,}$/i.test(normalizeText(value));

export const buildClientLineProofKey = ({
  client_line_id,
  clientLineId,
  client_request_id,
  clientRequestId,
} = {}) => {
  const lineId = normalizeText(client_line_id ?? clientLineId);
  if (!lineId) return null;
  const requestId = normalizeText(client_request_id ?? clientRequestId);
  return `${requestId}::${lineId}`;
};

export const reconcileDraftsWithSettledLines = (
  pendingItems = [],
  settledLines = [],
) => {
  const exactProofs = new Set();
  const provenLineIds = new Set();
  (Array.isArray(settledLines) ? settledLines : []).forEach((line) => {
    const key = buildClientLineProofKey(line);
    if (!key) return;
    exactProofs.add(key);
    provenLineIds.add(
      normalizeText(line?.client_line_id ?? line?.clientLineId),
    );
  });

  const remaining = [];
  const settled = [];
  const unresolved = [];
  (Array.isArray(pendingItems) ? pendingItems : []).forEach((item) => {
    const key = buildClientLineProofKey(item);
    const lineId = normalizeText(item?.client_line_id ?? item?.clientLineId);
    const provenAcrossRetry =
      isGloballyUniqueDraftLineId(lineId) && provenLineIds.has(lineId);
    if (key && (exactProofs.has(key) || provenAcrossRetry)) {
      settled.push(item);
      return;
    }
    remaining.push(item);
    if (!lineId) unresolved.push(item);
  });

  return { remaining, settled, unresolved };
};
